// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

// @tanstack/react-query
import { QueryClientProvider } from '@tanstack/react-query';

// theme
import ThemeProvider from 'src/theme';

// components
import MotionLazy from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsProvider } from 'src/components/settings';
import { queryClient, defaultSettings } from 'src/compass/site/config';
// Imported by path, not the shared/components barrel: the barrel pulls in the whole component
// library, and this module is itself a dependency of much of it.
import CasPendingEmailsPill from 'src/compass/shared/components/CasPendingEmails/CasPendingEmailsPill';

import { IContextChildren } from '../util';
import AuthContextProvider from './AuthContextProvider';
import ApiContextProvider from './ApiContextProvider/ApiContextProvider';
import CasMsalProvider from './CasMsalProvider';
import DialogContextProvider from './DialogContextProvider';

export default function CasContextProviders({ children }: IContextChildren) {
  return (
    <CasMsalProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider defaultSettings={defaultSettings}>
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <QueryClientProvider client={queryClient}>
                  <ApiContextProvider>
                    <DialogContextProvider>
                      <AuthContextProvider>
                        {children}
                        {/* Global and fixed-position, so it's mounted here rather than in
                            CasHeader - the header's AppBar is z-index capped below dialogs. */}
                        <CasPendingEmailsPill />
                      </AuthContextProvider>
                    </DialogContextProvider>
                  </ApiContextProvider>
                </QueryClientProvider>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </CasMsalProvider>
  );
}
